import { ROUTES } from '@utils/routes.ts';

import { config } from '@/config.ts';

const isCom2 = config.BRAND === 'com2';
const isNgu3 = config.BRAND === 'ngu3';

type NavItem = {
	key: string;
	path: string;
	labelKey: string;
	devOnly?: boolean;
	onlyLoggedIn?: boolean;
};

export const navList: NavItem[] = [
	{ key: 'home', path: ROUTES.HOME, labelKey: 'main' },
	{ key: 'shop', path: ROUTES.SHOP, labelKey: 'shop' },
	{ key: 'shop_main', path: ROUTES.HOME, labelKey: 'bonus_shop' },
	{ key: 'quests', path: ROUTES.QUESTS, labelKey: 'quests', onlyLoggedIn: isCom2 || isNgu3 },
	{ key: 'about_shop', path: ROUTES.HOME, labelKey: 'about_shop' },
	{ key: 'tournaments', path: ROUTES.TOURNAMENTS, labelKey: 'tournaments' },
	{ key: 'promotions', path: ROUTES.PROMOTIONS, labelKey: 'promotions' },
	{ key: 'faq', path: ROUTES.FAQ, labelKey: 'FAQ' },
	{ key: 'coin_race', path: ROUTES.COIN_RACE, labelKey: 'coin_race' },
	{ key: 'info', path: ROUTES.INFO, labelKey: 'info' },
	{ key: 'support', path: ROUTES.SUPPORT, labelKey: 'help' },
	{ key: 'buy_history', path: ROUTES.PROFILE, labelKey: 'buy_history', onlyLoggedIn: true }
];

type BrandNavConfig = Record<string, string[]>;

export const brandNavMap: BrandNavConfig = {
	//pm and default убрал 'coin_race' так как пока доступен только для com2, но если в будущем он будет добавлен, то нужно будет вернуть
	default: ['home', 'shop', 'quests', 'tournaments', 'promotions', 'info'],
	pm: ['home', 'shop', 'quests', 'tournaments', 'promotions', 'info'],
	rockets: ['shop', 'quests'],
	rockets_vip: ['shop', 'quests'],
	ngu3: ['home', 'shop', 'quests', 'info'],
	// According to task 2138, close for COM2
	com2: ['home', 'shop', 'quests', 'info'],
	nomad: ['shop', 'quests', 'about_shop'],
	blitz: ['shop_main', 'support'],
	sk2: ['shop_main', 'quests', 'buy_history']
};

/**
 * Items to hide when user is logged in for specific brands
 */
export const hideWhenLoggedInMap: Record<string, string[]> = {
	ngu3: ['home'],
	com2: ['home']
};

export const getNavListForBrand = (brand: string, isAuthenticated?: boolean): NavItem[] => {
	const allowedKeys = brandNavMap[brand] ?? brandNavMap.default;
	const hideWhenLoggedIn = hideWhenLoggedInMap[brand] || [];
	const isDevEnv = config.ENV === 'development';

	return navList.filter(item => {
		if (!allowedKeys.includes(item.key)) return false;
		if (isAuthenticated && hideWhenLoggedIn.includes(item.key)) return false;
		if (item.devOnly && !isDevEnv) return false;
		return true;
	});
};
